<template>
    <div id="app">
        <header>
            <nav>
            <a href="/" class="logo">
                <img src="./assets/WSFS_Wealth_institutional_services_logo.png" alt="WSFS Institional Services">
            </a>
            <div class="right" v-if="user">
                <router-link v-if="user.superuser" to="/users">Users</router-link>
                <router-link v-if="user.superuser" to="/access-requests">Access Requests</router-link>
                <router-link to="/profile">Edit Profile</router-link>
                <a href="#" class="logout" @click.prevent="logout">Sign Out</a>
            </div>
            </nav>
        </header>
        <main>
            <app-notifications />
            <search-box />
            <router-view/>
        </main>
        <footer>
            <div class="grid">
                <div class="white-logo">
                    <img src="./assets/logo_white.png" alt="WSFS Institional Services">
                </div>
                <div class="disclaimer">
                    <a href="/">Disclaimer and Terms of Service</a>
                </div>
                <div class="copyright">
                    © {{ copyrightYear }} Wilmington Savings Fund Society, FSB | Member FDIC
                </div>
            </div>
        </footer>
        <modal class="access-dialog" :show="requestingAccess" @close="closeRequestAccess">
            <h5>Request Access</h5>
            <div class="access-disclosure" v-if="requestingAccess">
            <p><strong>{{ requestingAccess.file.display_name }}</strong></p> 

            <p>
                The Certifying Party as defined below hereby agrees that the name and other
                information on the Wilmington Savings Fund Society, FSB (the “WSFS”) Reporting
                Website (the “wsfsabsreporting.com”) registration page with which this
                certification is completed is true, correct and accurate for contact purposes
                by WSFS, if necessary, and that the “Certifying Party” is authorized to
                complete this form.
            </p>

            <p>
                The Certifying Party is hereby requesting access to the specific transaction
                listed above in order to obtain certain transaction information (the
                “Transaction Information”) that is available on wsfsabsreporting.com.  In the
                event that the Certifying Party is no longer a party to the transaction
                specified above, the Certifying Party will notify WSFS so that Certifying
                Party’s access to the specific transaction listed below can terminated by WSFS.
            </p>

            <p>
                In consideration of the WSFS’s disclosure to the Certifying Party of the
                Transaction Information, the Certifying Party hereby unconditionally agrees
                that the Transaction Information is confidential, and that such Transaction
                Information shall not, without the prior written consent of WSFS and the Issuer
                be disclosed to any party by the Certifying Party or by its officers,
                directors, partners, employees, agents or representatives (collectively, the
                “Representatives”) in any manner whatsoever, in whole or in part.
            </p>

            <div class="fields">
                <p>
                    <strong>Certifying Party</strong>
                </p>

                <p>
                    <label>Name</label>
                    <output>{{ user.name }}</output>
                </p>
                <p>
                    <label>Industry Role</label>
                    <output>{{ user.industry_role }}</output>
                </p>
                <p>
                    <label>Company</label>
                    <output>{{ user.company }}</output>
                </p>
                <p>
                    <label>Address</label>
                    <output class="pre">
                        {{ user.address }}{{ user.address2 ? "\n" + user.address2 : "" }}
                        {{ user.city }}, {{ user.state }} {{user.zipcode }}
                    </output>
                </p>
                <p>
                    <label>Work Phone</label>
                    <output>{{ user.work_phone }}</output>
                </p>
                <p>
                    <label>Email Address</label>
                     <output>{{ user.email }}</output>
                </p>
            </div>
            </div>
            <p>
                <button @click.prevent="sendAccessRequest(requestingAccess)">Request Access</button>
            </p>
        </modal>
    </div>
</template>
<script>
import axios from 'axios'
import {format} from 'date-fns';
import {mapState} from 'vuex';

import Modal from './components/Modal.vue'
import SearchBox from './components/SearchBox.vue'

export default {
    name: 'app',
    components: {Modal, SearchBox},
    computed: {
        ...mapState(['user', 'requestingAccess']),
        copyrightYear() {
            return format(new Date(), 'yyyy')
        }
    },
    methods: {
        async logout() {
            await this.$store.dispatch('showRequestAccess', null)
            await this.$store.dispatch('setCwd', {})
            await this.$store.dispatch('logout')
            this.$router.push('/login')
        },
        closeRequestAccess() {
            this.$store.dispatch('showRequestAccess', null)
        },
        async sendAccessRequest(item) {
            let r = await axios.post('/api/access-requests', {
                access_request: {
                    file_id: item.file.id
                },
            })

            if (r.status != 200) {
                return;
            }

            this.closeRequestAccess()
            this.$notify.success('Thank you! Your request has been sent.', 3000)
        }
    },
    created() {
        axios.get('/api/hb')
    },
}
</script>
<style lang="scss">
@import './scss/include-media';
#app {
    header {
        background: white;
        width: 100%;

        nav {
            height: 5rem;
            max-width: 87.5rem;
            margin: 0 auto;
            display: flex;
            padding: 0 5rem;

            flex-flow: row nowrap;
            justify-content: space-between;
            align-items:center;

            .logo {
                img {
                    width: 272px;
                }
            }

            .right {
                a {
                    margin-left: 12px;
                    color: #333;
                }
            }
        }
    }

    main {
        background: url('./assets/investor-reporting-bg.png') center center no-repeat transparent;
        background-size: cover;

        @include media(">tablet") {
            padding: 0 0 3.5rem 0;
            min-height: calc(100vh - 20rem);
        }
    }

    footer {
        width: 100%;
        background: #2D2D2D;
        color: white;

        .grid {
            max-width: 87.5rem;
            margin: 0 auto;
            padding: 1.5rem 5rem 2.5rem;

            display: grid;
            grid-template-areas: "logo . . disclaimer"
                        ". copy copy .";
            grid-template-columns: 300px 1fr 1fr 300px;

            // align-items: center;


            .white-logo {
                grid-area: logo;
                align-self: center;
                img {
                    display: block;
                    width: 100%;
                    height: auto;
                }
            }
            .disclaimer {
                grid-area: disclaimer;
                align-self: center;
                text-align: right;
                a {
                    color: white;
                }

            }
            .copyright {
                grid-area: copy;
                align-self: center;
                text-align: center;
            }

            @include media("<tablet") {
                padding: 1.5rem 1.5rem 2.5rem;
                grid-template-areas: "logo"
                                    "disclaimer"
                                    "copy";
                grid-template-columns: 1fr;

                .disclaimer {
                    text-align: center;
                }
            }
        }
    }

    .access-dialog {
        .access-disclosure {
            max-height: 40vh;
            overflow: auto;

            @include media('>tablet') {
                max-width: 67vw;
            }
            @include media('<=tablet') {
                max-width: 80vw;
            }
            @include media('<=phone') {
                max-width: 95vw;
            }

            margin-top: 1.5rem;
            margin-bottom: 1.5rem;

            p {
                margin-bottom: 1rem;

                label {
                    flex: 0 0 auto;
                    width: 25%;
                    max-width: 200px;
                    font-weight: bold;
                }

                output {
                    display: inline-block;
                }
            }

            .fields p {
                margin-bottom: 0.5rem;
                display: flex;
                flex-flow: row nowrap;
            }
        }
    }
}
</style>
